/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Supplier } from '@app/suppliers/suppliers/suppliers.model';
import { SuppliersFormComponent } from '@app/suppliers/suppliers/suppliers-form/suppliers-form.component';

@Injectable({
  providedIn: 'root',
})
export class SuppliersFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open supplier form
   * @param supplier Dialog data
   */
  public open(supplier: null | Supplier = null) {
    const modal = this.modalService.open(SuppliersFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.supplier = supplier;
    return modal.result;
  }
}
